import styled from 'styled-components';
import { Checkbox, Layout, Radio, Col, Button, Card, Upload, Row, DatePicker, TimePicker } from 'antd';

const UploadFiles = styled(Upload.Dragger)`
  .iconUpload {
    color: black;
    font-size: 15px;
  }
`;

const ColumnRadio = styled(Col)`
  padding-left: 4%;
`;

const MainFollowing = styled.div`
  width: 92%;

  .ant-card-body {
    padding: 10px 16px !important;
    padding-bottom: 0px !important ;
  }
`;
const LayoutContent = styled(Layout)`
  background-color: white;
  .title {
    color: grey;
    margin-bottom: 10px;
  }
  .iconTitle {
    color: grey;
    height: 25px;
  }
  .containerTextAreaSummary {
    height: 100% !important;
  }
  .textAreaSummary {
    resize: none;
    overflow: hidden;
  }
  .contact {
    margin-top: 20px;
  }
`;

const CustomCard = styled(Card)`
  margin-left: 19px;
  margin-bottom: 4%;
  border: none;
  border-radius: 5px;
  .ant-card-body {
    text-align: center;
    padding: 5px !important;
    border: none;
  }
`;

const CustomCardPdfOn = styled(Card)`
  border: none;
  border-radius: 5px;
  .ant-card-body {
    text-align: center;
    padding: 5px !important;
    border: none;
  }
`;

const SpaceButtons = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  padding-right: 8%;
  padding-bottom: 3%;
`;

const IconButtons = styled(Button)`
  &&.ant-btn {
    margin-left: 7px;
    width: 90%;
    border: none;
    padding: 0px;
    .icons {
      margin-top: 4px;
      color: lightgrey;
      width: 25px;
      height: 25px;
    }
  }
`;

const PdfButton = styled(Button)`
  &&.ant-btn {
    margin-left: 7px;
    width: 90%;
    border: none;
    background: red;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      color: white;
      font-size: 18px;
    }
  }
`;

const TableButton = styled(Button)`
  &&.ant-btn {
    margin-left: 7px;
    width: 90%;
    border: none;
    background: #00af50;
    padding: 0px;
    .icon {
      color: white;
      font-size: 18px;
    }
  }
`;

const NotificationButton = styled(Button)`
  &&.ant-btn {
    margin-left: 7px;
    width: 90%;
    border: none;
    background: #25d366;
    padding: 0;
    color: white !important;

    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &&.ant-btn svg {
    width: 20px;
  }
`;

const SendButton = styled(Button)`
  &&.ant-btn {
    margin-left: 7px;
    width: 90%;
    border: none;
    background: #008ee5;
    padding: 0px;
    padding-top: 5px;
    .icon {
      color: white;
      width: 19px;
    }
  }
`;

const DownloadButton = styled(Button)`
  &&.ant-btn {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    border: none;
    background: white;
    padding: 10px 5px;
    border-radius: 10px;
    margin-bottom: 10px;
    align-items: center;
    &:hover,
    &:focus {
      background: #f4f5f7;
      color: black;
    }
    span {
      padding-left: 3%;
    }
    .iconDownload {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: #008ee5;
      border-radius: 50%;
      padding-bottom: 3px;
      padding-left: 1px;
    }
    .icon {
      color: white;
      width: 23px;
    }
  }
`;

const CheckboxSummary = styled(Checkbox)`
  display: flex;
  align-items: center;
  p {
    margin: 0px;
    padding-top: 3px;
    color: #000 !important;
  }

  .ant-checkbox .ant-checkbox-inner {
    width: 25px;
    height: 25px;
    border-radius: 1px;
    border: 2px solid #d7d7d7;
    background-color: white !important;
    cursor: default;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #d7d7d7 !important;
    border: 1px solid #d7d7d7;
    width: 25px;
    height: 25px;
    border-radius: 1px;
    cursor: default;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    top: 40%;
    left: 25%;
    height: 15px;
    width: 7px;
    border-bottom: 3px solid #fff;
    border-right: 3px solid #fff;
    cursor: default;
  }
`;

const PaymentButton = styled(Button)`
  &&.ant-btn {
    margin-left: 7px;
    width: 90%;
    border: none;
    background: #009688;
    padding: 0px;
    padding-top: 5px;
    .icon {
      color: white;
      width: 19px;
    }
  }
`;

const RadioSummary = styled(Radio)`
  margin: 7px 0px;
  display: flex;
  align-items: center;
  p {
    margin: 0px;
    font-size: 12px;
    padding-top: 5px;
    color: #000 !important;
  }

  .ant-radio-disabled {
    background: #d7d7d7;
    border-radius: 50%;
    transform: scale(1.5);

    .ant-radio-wrapper {
      color: blue;
    }

    .ant-radio-inner {
      background: white;
      border-color: #d7d7d7;
    }
  }

  .ant-radio-checked {
    background: #d7d7d7;
    border-radius: 50%;
    border: 2px solid #d7d7d7;
    transform: scale(1.2);
    margin-left: -2px;

    .ant-radio-inner {
      background: #d7d7d7;
      border-color: white;
      border-width: 3px !important;
    }
    &:hover .ant-radio-inner {
      background: #d7d7d7; /* Cambia esto al color que desees */
    }

    &:hover {
      border-color: #d7d7d7 !important; /* Añade esto para cambiar el borde exterior */
    }
  }
`;

const TimeLinePointerIconWrap = styled.div`
  padding: 20px;
  .ant-timeline-item-last > .ant-timeline-item-tail {
    display: block;
  }
  .ant-timeline-item-tail {
    border-width: 3px;
  }
  .ant-timeline-item {
    padding-bottom: 28px;
    &:last-child {
      padding-bottom: 0;
    }
    &.primary {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #e7e8fd;
      }
    }
    &.info {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #dff0ff;
      }
    }
    &.warning {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #ffeeda;
      }
    }
    &.pink {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #ffe8f2;
      }
    }
    &.success {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #ddf7f0;
      }
    }
    &.update {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #e5e5e8;
      }
    }
    &.danger {
      background: transparent;
      .ant-timeline-item-head {
        background-color: #ffe4e5;
      }
    }
    .ant-timeline-item-head {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border-radius: 50%;
      &:after,
      &:before {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -8px;
        width: 8px;
        height: 8px;
        content: '';
        background-color: #fff;
      }
      &:before {
        top: auto;
        bottom: -8px;
      }
    }
    .ant-timeline-item-content {
      margin: ${({ theme }) => (theme.rtl ? '-38px 42px 0 0' : '-38px 0 0 42px')};
      h3 {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 30px;
        color: ${({ theme }) => theme['dark-color']};
      }
      p {
        font-size: 14px;
        font-weight: 400;
        max-width: 330px;
        margin-bottom: 12px;
      }
      .tags {
        font-size: 14px;
        color: ${({ theme }) => theme['light-gray-color']};
      }
    }
  }
`;

const UlSummary = styled.ul`
  list-style-type: 'none';
  font-weight: 200;
`;

const TitleSummary = styled.p`
  font-size: 14px;
  font-weight: bold;
`;

const ButtonUpload = styled(Button)`
  min-width: 50px;
  color: #fa8b0b !important;
  margin-left: 20px;
`;

const ContentActionsImg = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  gap: 5px;
  z-index: 2;

  .btnPreview {
    background-color: white;
    border-radius: 50%;
    color: #22baf2;
    border-color: transparent;
  }
  .btnDelete {
    background-color: white;
    border-radius: 50%;
    color: gray;
    border-color: transparent;
  }
`;

const BtnUploadModal = styled(Button)``;

const ContentUpload = styled(Row)``;

const ButtonEditSummary = styled(Button)`
  border: none;
  color: #fa8b0b;
  box-shadow: none;
`;

const ContentBtnEdit = styled(Row)`
  // border-radius: 50%;
  // max-width: 100px;
  // background-color: #f2f2f2;
  // margin-bottom: 14px;
`;

const ButtonCheck = styled(Button)`
  border: none;
  color: #3abdf3;
  box-shadow: none;
  background-color: transparent;
  margin-right: 0px !important;
  padding-left: 5px;
  height: 2em;
  padding: none;

  &:hover {
    background-color: transparent;
    color: #2d99ff;
  }
`;

const ButtonX = styled(Button)`
  border: none;
  color: #ff231f;
  height: 2em;
  padding: none;
  box-shadow: none;
  background-color: transparent;
  margin-right: 0px !important;
  padding-right: 5px;
`;

const ContentBtnX = styled(Row)`
  border-radius: 50%;
  max-width: 100px;
  background-color: #ffe8f1;
`;

const ContentBtnCheck = styled(Row)`
  border-radius: 50%;
  max-width: 100px;
  background-color: #e0f0ff;
`;

const DatePickerStyle = styled(DatePicker)`
  min-height: 50px !important;
`;

const TimePickerStyle = styled(TimePicker)`
  min-height: 50px !important;
`;

const ChildItemsContainer = styled.div`
  margin: 10px;
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 20px;
`;

const TagsButton = styled(Button)`
  border: none;
  width: 92%;
  margin-bottom: 4%;
  color: ${(props) => props.textColor} !important;
  background: ${(props) => props.backgroundButton};
  white-space: normal;
  word-break: break-word;
  height: auto;
  padding: 8px 12px;
  line-height: 1.2;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
    white-space: normal;
    word-break: break-word;
    text-align: center;
  }

  &:hover,
  &:focus,
  &:active {
    color: ${(props) => props.textColor} !important;
    background: ${(props) => props.backgroundButton} !important;
    opacity: 0.8;
    cursor: ${(props) => (props.isActiveForm ? 'pointer' : 'not-allowed')};
  }
`;

const LateralContainer = styled(Row)`
  .video {
    display: flex;
    background: #595bdd;
    justify-content: center;
    vertical-align: center;
    margin: auto;
    color: white;
    margin-left: 7px;
    width: 90%;
    border: none;
    padding: 0px;
    .icon {
      margin-top: 6px;
      color: white;
      font-size: 18px;
    }
  }
`;

export {
  MainFollowing,
  LayoutContent,
  CheckboxSummary,
  RadioSummary,
  UlSummary,
  ColumnRadio,
  TimeLinePointerIconWrap,
  UploadFiles,
  CustomCard,
  SpaceButtons,
  CustomCardPdfOn,
  IconButtons,
  PdfButton,
  TableButton,
  SendButton,
  DownloadButton,
  TitleSummary,
  PaymentButton,
  ButtonUpload,
  ContentActionsImg,
  BtnUploadModal,
  ContentUpload,
  ButtonEditSummary,
  ButtonCheck,
  ButtonX,
  DatePickerStyle,
  ContentBtnX,
  ContentBtnCheck,
  ContentBtnEdit,
  TimePickerStyle,
  ChildItemsContainer,
  TagsButton,
  LateralContainer,
  NotificationButton,
};
